
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-your-doctor-wasnt-taught",
      function () {
        return require("private-next-pages/what-your-doctor-wasnt-taught/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-your-doctor-wasnt-taught"])
      });
    }
  